import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ff404484"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ModalShopList_Content" }
const _hoisted_2 = { class: "ModalShopList_Header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ModalShopList_Header_Title" }, "イベント選択", -1))
const _hoisted_4 = { class: "ModalShopList_Main" }
const _hoisted_5 = { class: "ModalShopList_TableContainer" }
const _hoisted_6 = { class: "ModalShopList_Table" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "選択"),
    /*#__PURE__*/_createElementVNode("th", null, "イベント名")
  ])
], -1))

import { reactive } from "vue";
import { useStore } from "vuex";
import BtnGreenSmall from "../atoms/button/BtnGreenSmall.vue";

interface EventData {
  id: number;
  eventName: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ModalEventList',
  emits: ["close", "ref_selectEvent"],
  setup(__props, { emit: __emit }) {

const store = useStore();
const emit = __emit;
// テーブル表示項目----------------------------------------------
const eventList = store.getters["constant/getEventList"];

//モーダル開閉---------------------------
const closeModal = () => {
  emit("close");
};

//商品選択-------------------------------
const selectEvent = (event: EventData): void => {
  if (window.confirm(`「${event}」を選択してもよろしいですか？`)) {
    emit("ref_selectEvent", event);
    closeModal();
  }
};

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      class: "ModalShopList",
      onClick: closeModal
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_font_awesome_icon, {
          onClick: closeModal,
          class: "ModalShopList_Header_Close",
          icon: "xmark"
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("table", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(eventList), (event, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", null, [
                    _createVNode(BtnGreenSmall, {
                      onClick: ($event: any) => (selectEvent(event)),
                      class: "ModalShopList_BtnGreenSmall"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("選択")
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _createElementVNode("td", null, _toDisplayString(event), 1)
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})